import React, { Component } from 'react'
import $ from 'lib/jquery'
import { SmoothScroll } from 'foundation-sites'
import MapDetails from './map-details'
import Current from 'frontend/lib/current'

export default class Map extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.markers = []
    this.apiKey = document.body.dataset.mapApiKey
    this.markerIcon = document.body.dataset.markerIcon
    this.markerIconActive = document.body.dataset.markerIconActive
  }

  componentDidMount () {
    if (typeof window.google !== 'undefined' && typeof window.google.maps !== 'undefined') {
      this.initMap()
    } else {
      $.getScript(
        `https://maps.google.com/maps/api/js?key=${this.apiKey}&language=en&region=US`,
        () => {
          this.initMap()
        }
      )
    }
  }

  initMap () {
    if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {
      this.waitGoogleMapsInterval = setInterval(this.initMap.bind(this), 200)
    } else {
      if (this.waitGoogleMapsInterval) {
        clearInterval(this.waitGoogleMapsInterval)
      }

      this.bounds = new window.google.maps.LatLngBounds()
      this.map = new window.google.maps.Map(this.mapElement, this.constructor.mapOptions)

      // TODO: parallel maps api and locations.js loading
      this.fetchLocations()
    }
  }

  fetchLocations () {
    $.ajax({
      type: 'get',
      url: '/' + Current.cityId + '/locations.json',
      error: (response) => {
        console.debug('Map#fetchLocations(): Error fetching locations.json', response)

        this.setState({ errorMessage: 'Error fetching locations from server' })
      },
      success: (response) => {
        this.handleLocations(response)
      }
    })
  }

  handleLocations (locations) {
    // TODO: wait till maps api loaded
    for (let i = locations.length - 1; i >= 0; i--) {
      const position = new window.google.maps.LatLng(locations[i].latitude, locations[i].longitude)
      this.addMarker(position, locations[i])
      this.bounds.extend(position)
    }

    window.google.maps.event.trigger(this.map, 'resize')
    this.map.fitBounds(this.bounds)
    this.map.panToBounds(this.bounds)

    this.setState({ locations })
  }

  addMarker (position, location) {
    const marker = new window.google.maps.Marker({
      position,
      map: this.map,
      icon: this.markerIcon,
      location
    })

    marker.addListener('click', () => {
      this.handleMarkerClick(marker)
    })

    location.marker = marker

    this.markers.push({
      marker
    })
  }

  handleMarkerClick (marker) {
    this.handleSelect(marker.location)
  }

  handleSelect (location) {
    const index = this.state.locations.findIndex((other) => {
      return other.id === location.id
    })

    this.updateMarker(location)

    this.setState(
      {
        selectedLocation: location,
        previousLocation: this.state.locations[index - 1],
        nextLocation: this.state.locations[index + 1]
      },
      function () {
        SmoothScroll.scrollToLoc('#location_details', {
          threshold: 50,
          offset: 100
        })
      }
    )
  }

  updateMarker (location) {
    for (var i = 0, m; (m = this.markers[i]); i++) {
      m.marker.setIcon(this.markerIcon)
    }

    location.marker.setIcon(this.markerIconActive)
    this.map.panTo(location.marker.getPosition())
  }

  renderErrorMessage () {
    if (this.state.errorMessage) {
      return (
        <div className="alert callout" data-closable>
          <p>{this.state.errorMessage}</p>
        </div>
      )
    }
  }

  render () {
    return (
      <div id="locations_map">
        {this.renderErrorMessage()}
        <div
          className="map"
          ref={(mapElement) => {
            this.mapElement = mapElement
          }}
        ></div>
        <MapDetails
          location={this.state.selectedLocation}
          previousLocation={this.state.previousLocation}
          nextLocation={this.state.nextLocation}
          onSelect={this.handleSelect.bind(this)}
        />
        <img src={this.markerIcon} width={1} height={1} />
        <img src={this.markerIconActive} width={1} height={1} />
      </div>
    )
  }
}

Map.mapOptions = {
  zoom: 16,
  scrollwheel: false,
  styles: [
    {
      featureType: 'road.highway',
      elementType: 'labels',
      stylers: [
        { hue: '#ffffff' },
        { saturation: -100 },
        { lightness: 100 },
        { visibility: 'off' }
      ]
    },
    {
      featureType: 'landscape.natural',
      elementType: 'all',
      stylers: [
        { hue: '#ffffff' },
        { saturation: -100 },
        { lightness: 100 },
        { visibility: 'on' }
      ]
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [{ hue: '#ffe94f' }, { saturation: 100 }, { lightness: 4 }, { visibility: 'on' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ hue: '#ffe94f' }, { saturation: 100 }, { lightness: 4 }, { visibility: 'on' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        { hue: '#333333' },
        { saturation: -100 },
        { lightness: -74 },
        { visibility: 'off' }
      ]
    }
  ]
}
